import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { CorvinusMark } from '@/components/brand/CorvinusLogo'

/**
 * Boot / loading screen — Figma `webapp-light-en › 1440px` (2206:280388)
 * and `400px` (2206:280404).
 *
 * Geometry taken 1:1 from the design: the mark is centred in the viewport,
 * "from" sits 80px above the bottom edge and the "Corvinus" line box ends
 * 40px (≥600px) / 41px (<600px) above it.
 */
export function SplashScreen(): ReactElement {
  const { t } = useTranslation()

  return (
    <div
      className="bg-canvas relative min-h-dvh w-full overflow-hidden"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <CorvinusMark
        data-node-id="2732:90237"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 drop-shadow-[0px_0px_6px_rgba(0,0,0,0.04)]"
        title="Corvinus"
      />

      <p
        data-node-id="2206:280389"
        className="hub-title-lg text-widget-primary absolute bottom-[80px] left-1/2 -translate-x-1/2 text-center whitespace-nowrap"
      >
        {t('splash.from')}
      </p>
      <p
        data-node-id="2206:280390"
        className="hub-display-lg text-widget-primary absolute bottom-[41px] left-1/2 -translate-x-1/2 text-center whitespace-nowrap sm:bottom-[40px]"
      >
        {t('splash.brand')}
      </p>
    </div>
  )
}
